import Api from '@/apis/businessApi'
import Store from '@/store'
import i18n from '@/i18n'

export default {
  async getInvoices (page, pageSize, resellerUid, dates) {
    var getInvoicesUrl = '/v1/admin/invoices'
    var querystringParams = []
    if (Number.isInteger(page) && page >= 0) {
      querystringParams.push(`page=${page}`)
      if (pageSize) {
        querystringParams.push(`pageSize=${pageSize}`)
      }
    }
    if (dates && dates.length > 0) {
      querystringParams.push(`startDateTime=${dates[0]}`)
      if (dates.length === 2) {
        querystringParams.push(`endDateTime=${dates[1]}`)
      }
    }
    if (resellerUid) {
      querystringParams.push(`resellerUid=${resellerUid}`)
    }

    if (querystringParams.length > 0) {
      getInvoicesUrl += '?' + querystringParams.join('&')
    }
    return Api()
      .get(getInvoicesUrl)
      .then(async function (response) {
       return  { success: true, value: response }
      })
      .catch(async function (error) {
        await Store.dispatch('SetSnackBarMessage', {
          message: i18n.t('Services.Admin.Invoice.Messages.GetInvoicesErrorMessage'),
          color: 'error',
        })
        console.error(error)
        return { success: false }
      })
  },
  async getExportInvoices ( resellerUid, dates) {
    var getExportInvoicesUrl = '/v1/admin/invoices/export'
    var querystringParams = []

    if (dates && dates.length > 0) {
      querystringParams.push(`startDateTime=${dates[0]}`)
      if (dates.length === 2) {
        querystringParams.push(`endDateTime=${dates[1]}`)
      }
    }
    if (resellerUid) {
      querystringParams.push(`resellerUid=${resellerUid}`)
    }

    if (querystringParams.length > 0) {
      getExportInvoicesUrl += '?' + querystringParams.join('&')
    }
    return Api()
      .get(getExportInvoicesUrl, {responseType: 'arraybuffer'})
      .then(async function (response) {
        let blob = new Blob([response.data], { type: 'application/xlsx' })
        let link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        link.download = new Date().toJSON().split('T')[0].split('-').join('') +'_Invoice Detail.xlsx'
        link.click()
        return { success: true, value: response }
      })
      .catch(async function (error) {
        await Store.dispatch('SetSnackBarMessage', {
          message: i18n.t('Services.Admin.Invoice.Messages.GetExportInvoicesErrorMessage'),
          color: 'error',
        })
        console.error(error)
        return { success: false }
      })
  },
  async getInvoice (uid) {
    return Api()
      .get('/v1/admin/invoices/' + uid)
      .then(async function (response) {
        return { success: true, value: response }
      })
      .catch(async function (error) {
        await Store.dispatch('SetSnackBarMessage', {
          message: i18n.t('Services.Admin.Invoice.Messages.GetInvoiceErrorMessage', [uid.substr(6)]),
          color: 'error',
        })
        console.error(error)
        return { success: false }
      })
  },
  async createBillingPeriods (resellerUid, cutOffDate) {
    var createBillingPeriodUrl = '/v1/admin/invoicing/createBillingPeriods'
    var querystringParams = []
    if (cutOffDate) {
      querystringParams.push(`cutOffDate=${cutOffDate}`)
    }
    if (resellerUid) {
      querystringParams.push(`resellerId=${resellerUid}`)
    }
    if (querystringParams.length > 0) {
      createBillingPeriodUrl += '?' + querystringParams.join('&')
    }
    return Api()
      .get(createBillingPeriodUrl)
      .then(async function (response) {
        return { success: true, value: response }
      })
      .catch(async function (error) {
        await Store.dispatch('SetSnackBarMessage', {
          message: i18n.t('Services.Admin.Invoice.Messages.CreateBillingPeriodsError'),
          color: 'error',
        })
        console.error(error)
        return { success: false }
      })
  },
  async processDraftInvoices (resellerUid) {
    var processDraftInvoicesUrl = '/v1/admin/invoicing/processDraftInvoices'
    var querystringParams = []
    if (resellerUid) {
      querystringParams.push(`resellerId=${resellerUid}`)
    }
    if (querystringParams.length > 0) {
      processDraftInvoicesUrl += '?' + querystringParams.join('&')
    }
    return Api()
      .get(processDraftInvoicesUrl)
      .then(async function (response) {
        return { success: true, value: response }
      })
      .catch(async function (error) {
        await Store.dispatch('SetSnackBarMessage', {
          message: i18n.t('Services.Admin.Invoice.Messages.ProcessDraftInvoicesError'),
          color: 'error',
        })
        console.error(error)
        return { success: false }
      })
  },
}
